import axios from "axios";
import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;


export default {
    async fetchSuggestions(query) {
        const url = `${URL}v1/cms/suggestions${query}`;
        return (await httpClient.get(url)).data;
    },
};
